<template>
  <div>
    <van-cell-group><van-field label="宗地标识" :value="data.landSign" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="宗地编号" :value="data.landNo" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="行政区" :value="data.administrativeArea" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地面积（公顷）" :value="data.acreage" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="宗地地址" :value="data.address" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地他项权利人证号" :value="data.obligeeNo" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地使用权证号" :value="data.usufructNo" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地抵押人名称" :value="data.mortgagorName.name" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地抵押人性质" :value="data.mortgagorNature" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地抵押权人" :value="data.mortgagePeople.name" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="抵押土地用途" :value="data.mortgagePurpose" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="抵押土地权属性质与使用权类型" :value="data.natureAndType" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="抵押面积（公顷）" :value="data.mortgageAcreage" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="评估金额（万元）" :value="data.assessmentPrice" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="抵押金额（万元）" :value="data.mortgagePrice" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地抵押登记起始时间" :value="data.onBoardStartTime" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="土地抵押结束时间" :value="data.onBoardEndTime" placeholder="无" readonly /></van-cell-group>
  </div>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "adminPenaltyCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>